import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import useLoan from 'hooks/useLoan';
import routes from 'resources/routes.json';

import { getCounterOffer, FIND_COUNTER_OFFER_SUCCESS } from '../../../../../store/actions/application-actions';
import { findCurrentLoan } from '../../../../../store/actions/customer-actions';
import { goToLoanRoute } from '../../../../../navigation/application-routes';
import { isMobile } from '../../../../../utils/helper/page-behavior-helper';

import Loading from 'components/features/loading/loading';
import { Button, Container, Typography } from 'lib-ui-react';
import useEvents from '../../../../../hooks/useEvents';

function CounterOfferInstallmentDueDate() {
  const dispatch = useDispatch();
  const { dispatchCompleteEvent } = useEvents('application-customer-portal-web-page-contract-recurring-counter-offer', 'recurring-counter-offer')
  const { device, loan } = useLoan();

  const [loading, setLoading] = useState(false);
  const [payDay, setPayDay] = useState();
  const footerStyle = isMobile() ? { position: 'fixed', bottom: 0, left: 0 } : {};

  function handleValidPayDay(e) {
    setPayDay(e.target.value <= 30 ? e.target.value.replace(/[^\d]/g, '').replace(/(\d{1,2})/, '$1') : 0);
  }

  function handleFirstInstallmentDueDateChange() {
    dispatchCompleteEvent('loan-first-installment-due-date-change-pay-day')
    setLoading(true);
    dispatch(getCounterOffer(device, 'loan-first-installment-due-date', '', loan?.id, payDay)).then((response) => {
      if (response.type === FIND_COUNTER_OFFER_SUCCESS) {
        dispatch(findCurrentLoan(device)).then(({ payload: loan }) => {
          setLoading(false);
          sessionStorage.setItem('startProcessCounterOfferRecurrent', false);
          sessionStorage.setItem('betterConditionsFinded', true);
          goToLoanRoute(loan, routes.LOAN_COUNTER_OFFER_PROCESS, routes.LOAN_APPLICATION_CONTRACT);
        });
      }
    });
  }

  if (loading) {
    return (
      <>
        <Loading title="Aguarde um momento, por favor..." />
      </>
    );
  }

  return (
    <>
      <Container spacing={24} padding={16} height="100vh">
        <Container spacing={8}>
          <Typography type="title" size="medium" fontWeight={400} lineHeight="28px" color="#2A2B35">
            Qual data você prefere pagar a sua primeira parcela?
          </Typography>

          <Typography size="small" fontWeight={400} lineHeight="20px" color="#757575">
            Pense em um dia do mês confortável para pagar a parcela do seu empréstimo.
          </Typography>
        </Container>

        <Container align="flex-start" justify="center" spacing={4}>
          <Typography size="small" fontWeight={700} lineHeight="18px">
            Digite um número entre 1 e 30
          </Typography>
          <input
            id="dayOfDueDate"
            placeholder="ex: 4"
            pattern="\d{1,2}"
            maxLength={2}
            min={1}
            max={30}
            value={payDay}
            onChange={handleValidPayDay}
            style={{
              boxSizing: 'border-box',
              border: '1px solid #C5C7D4',
              borderRadius: '8px',
              margin: '0',
              minWidth: '328px',
              maxHeight: '48px',
              padding: '16px 12px 16px 12px',
            }}
          />
        </Container>
      </Container>
      <Container
        align="center"
        justify="center"
        padding="16px"
        spacing={8}
        background="#fff"
        width="100%"
        style={footerStyle}
      >
        <Button margin="0" style={{ maxWidth: 'none' }} onClick={handleFirstInstallmentDueDateChange}>
          Continuar
        </Button>
      </Container>
    </>
  );
}

export default CounterOfferInstallmentDueDate;
